import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import '../css/StaticBanner.css';
import {GenericContext} from "./App";

library.add(faExclamationTriangle);

export default function StaticBanner({message, icon, color, backgroundColor}) {
    const { userOptions } = React.useContext(GenericContext);

    return (
      <div className={`static-banner ${userOptions.showPermanentAlertsBar ? 'permanent-bar' : ''}`} style={{color: color, backgroundColor: backgroundColor}}>
        {(icon !== null) && (
          <FontAwesomeIcon className="static-banner-icon" icon={icon}/>
        )}
        <span className="static-banner-message">{message}</span>
      </div>
    )
}
  